<template>
    <el-container style="padding: 0px">
        <el-aside width="240px" style="padding-top:90px">


            <el-row type="flex" justify="start" align="middle" v-for="(item,index) in reportArray" :key="index"
                :class="{options:true,optionsActive:tabActive == index}" @click.native="calendar(item,index)">
                <span>{{item.report_name}}</span></el-row>

            <!--            <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:tabActive==2}"-->
            <!--                    @click.native="calendar2"><span>签到看板</span></el-row>-->
            <!--            <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:tabActive==3}"-->
            <!--                    @click.native="calendar3"><span>拜访覆盖分析</span></el-row>-->
            <!--            <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:tabActive==4}"-->
            <!--                    @click.native="calendar4"><span>辅导/协访统计</span></el-row>-->
            <!--            <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:tabActive==5}"-->
            <!--                    @click.native="calendar5"><span>辅导/协访分析</span></el-row>-->
            <!--            <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:tabActive==6}"-->
            <!--                    @click.native="calendar6"><span>会议活动分析</span></el-row>-->
            <!--            <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:tabActive==7}"-->
            <!--                    @click.native="calendar7"><span>销售数据统计</span></el-row>-->
        </el-aside>
        <el-main>

            <!-- includePageNames是数组，用来存放需要缓存的页面的路由中的path或者name的 -->
            <router-view v-if="reportArray.length > 0"></router-view>
        </el-main>
    </el-container>

</template>
<script>
    import http from '../../APIService/http'
    export default {
        name: "StateMent",
        components: {
        },
        data() {
            return {
                tabActive: 0,
                options: [],
                includePageNames: [],
                reportArray: []
            }
        },
        created() {
            this.tabActive = localStorage.getItem('tabActive')
        },
        mounted() {
            this.init()
        },
        methods: {
            async init() {

                // let loading = this.$loading({
                //     lock: true,
                //     text: '拼命加载中',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.7)'
                // });

                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        user_id: user.user_id,
                        tenant_id: user.tenant_id,
                        role: user.role
                    }
                    await http.post('/wapi/v1/getRolePermissionsReport', data).then(res => {

                        if (res.success) {
                            this.reportArray = res.data
                            console.log(this.reportArray)
                            var compare = function (obj1, obj2) {
                                var val1 = obj1.sort;
                                var val2 = obj2.sort;
                                if (val1 < val2) {
                                    return -1;
                                } else if (val1 > val2) {
                                    return 1;
                                } else {
                                    return 0;
                                }
                            }
                            this.reportArray.sort(compare)

                            this.calendar(this.reportArray[0], 0);
                            // loading.close()
                        }
                        // loading.close()
                    })
                } catch (e) {
                    // loading.close()
                }
            },

            calendar(item, index) {

                localStorage.setItem('tabActive', index)
                this.tabActive = localStorage.getItem('tabActive')

                if (item.report_type === 'RPT_TERRITORY') {
                    this.$router.push({
                        path: '/statement/overview'
                    })
                } else if (item.report_type === 'RPT_CHECKIN') {
                    this.$router.push({
                        path: '/statement/reception'
                    })
                } else if (item.report_type === 'RPT_CLIENT_COVERAGE') {
                    this.$router.push({
                        path: '/statement/visitCover'
                    })
                } else if (item.report_type === 'RPT_COACHING2') {
                    this.$router.push({
                        path: '/statement/TutoringAnalysis'
                    })
                } else if (item.report_type === 'RPT_COACHING2_Q') {
                    this.$router.push({
                        path: '/statement/TutoringAnalysisReport'
                    })
                } else if (item.report_type === 'RPT_CAMPAIGN') {
                    this.$router.push({
                        path: '/statement/EventAnalysis'
                    })
                } else if (item.report_type === 'RPT_SALES_DATA') {
                    this.$router.push({
                        path: '/statement/SalesStatistical'
                    })
                } else if (item.report_type === 'RPT_COACHING') {
                    this.$router.push({
                        path: '/statement/TutoringReport'
                    })
                } else if (item.report_type === 'RPT_DATA_EXPORT') {
                    this.$router.push({
                        path: '/statement/dataExport'
                    })
                }  else if (item.report_type === 'RPT_DATA_EXPORT_SFE') {
                    this.$router.push({
                        path: '/statement/SfeExport'
                    })
                } else if (item.report_type === 'RPT_CHECKIN_DATA') {
                    this.$router.push({
                        path: '/statement/SignKanBan'
                    })
                } else if (item.report_type === 'RPT_HALF_DATA') {
                    this.$router.push({
                        path: '/statement/DayAffairKanBan'
                    })
                } else if (item.report_type === 'RPT_INSTITUTION_CALL') {
                    this.$router.push({
                        path: '/statement/AgencyVisited'
                    })
                } else if (item.report_type === 'RPT_TERRITORY_DATA') {
                    this.$router.push({
                        path: '/statement/PopedomOverview'
                    })
                } else if (item.report_type === 'RPT_LUOSHI_COLLECTION') {
                    this.$router.push({
                        path: '/statement/LuoshiReportProgress'
                    })
                } else if (item.report_type === 'RPT_BOJIAN_COLLECTION') {
                    this.$router.push({
                        path: '/statement/BojianReportProgress'
                    })
                }else if (item.report_type === 'RPT_DATA_EXPORT_LUOSHI_NIMING') {
                    this.$router.push({
                        path: '/statement/LuoshiNimingExport'
                    })
                }else if (item.report_type === 'CSO_SALES_DATA_EXPORT') {
                    this.$router.push({
                        path: '/statement/CSO_SalesDataReport'
                    })
                }
            },



            // calendar1() {
            //     this.$router.push({
            //         path: '/statement/overview'
            //     })
            //     localStorage.setItem('tabActive', 1)
            //     this.tabActive = localStorage.getItem('tabActive')
            // },
            // calendar2() {
            //     this.$router.push({
            //         path: '/statement/reception'
            //     })
            //     localStorage.setItem('tabActive', 2)
            //     this.tabActive = localStorage.getItem('tabActive')
            // },
            // calendar3() {
            //     this.$router.push({
            //         path: '/statement'
            //     })
            //     localStorage.setItem('tabActive', 3)
            //     this.tabActive = localStorage.getItem('tabActive')
            // },
            // calendar4() {
            //     this.$router.push({
            //         path: '/statement/TutoringReport'
            //     })
            //     localStorage.setItem('tabActive', 4)
            //     this.tabActive = localStorage.getItem('tabActive')
            // },
            // calendar5() {
            //     this.$router.push({
            //         path: '/statement/TutoringAnalysis'
            //     })
            //     localStorage.setItem('tabActive', 5)
            //     this.tabActive = localStorage.getItem('tabActive')
            // },
            // calendar6() {
            //     this.$router.push({
            //         path: '/statement/EventAnalysis'
            //     })
            //     localStorage.setItem('tabActive', 6)
            //     this.tabActive = localStorage.getItem('tabActive')
            // },
            // calendar7() {
            //     this.$router.push({
            //         path: '/statement/SalesStatistical'
            //     })
            //     localStorage.setItem('tabActive', 7)
            //     this.tabActive = localStorage.getItem('tabActive')
            // },
        },
        beforeRouteLeave(to, from, next) {
            localStorage.setItem('tabActive', 0)

            next();
        },
        beforeRouteUpdate(to, from, next) {
            if (to.name === 'statement') {
                this.active = 0
            }
            next();
        }

    }
</script>
<style scoped>
    .el-aside {
        background: #F4F6F8;
        padding: 15px 0;
        /*border: 1px solid #DCDFE6;*/
    }

    .el-main {
        background: white;
        /*border: 1px solid #DCDFE6;*/
        border-left: none;
        padding: 20px 20px;
    }

    .options {
        cursor: pointer;
        height: 45px;
        font-family: 'Hiragino Sans GB';
        font-size: 16px;
        color: #323232;
        padding-left: 70px;
        user-select: none;
    }

    .ico1:before {

        content: '';
        display: inline-block;
        width: 20px;
        height: 20px;
        text-align: center;
        background: url("../../assets/images/Fill2.png") no-repeat center;
        margin-right: 20px;
        background-size: cover;
    }

    .ico2:before {
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        background: url("../../assets/images/ico1.png") no-repeat center;
        margin-right: 20px;
        background-size: contain;
    }

    .ico3:before {
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        background: url("../../assets/images/diction1.png") no-repeat center;
        margin-right: 20px;
        background-size: contain;
    }

    .ico4:before {
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        background: url("../../assets/images/dataBank2.png") no-repeat center;
        margin-right: 20px;
        background-size: contain;
    }

    .ico5:before {
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        background: url("../../assets/images/systemParameter1.png") no-repeat center;
        margin-right: 20px;
        background-size: contain;
    }

    .ico6:before {
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        background: url("../../assets/images/productSku1.png") no-repeat center;
        margin-right: 20px;
        background-size: contain;
    }

    .optionsActive {
        cursor: pointer;
        height: 45px;
        font-family: Hiragino Sans GB;
        font-size: 16px;
        color: #323232;
        padding-left: 70px;
        user-select: none;
        color: #3998F7;
        font-weight: bold;
    }

    .ico1A:before {
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        margin-right: 20px;
        background: url("../../assets/images/Fill1.png") no-repeat center;
        background-size: contain;
    }

    .ico2A:before {
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        margin-right: 20px;
        background: url("../../assets/images/ico2.png") no-repeat center;
        background-size: contain;
    }

    .ico3A:before {
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        margin-right: 20px;
        background: url("../../assets/images/diction2.png") no-repeat center;
        background-size: contain;
    }

    .ico4A:before {
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        margin-right: 20px;
        background: url("../../assets/images/dataBank1.png") no-repeat center;
        background-size: contain;
    }

    .ico5A:before {
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        margin-right: 20px;
        background: url("../../assets/images/systemParameter2.png") no-repeat center;
        background-size: contain;
    }

    .ico6A:before {
        content: '';
        display: inline-block;
        width: 22px;
        height: 22px;
        text-align: center;
        margin-right: 20px;
        background: url("../../assets/images/productSku2.png") no-repeat center;
        background-size: contain;
    }

    .el-container {
        min-height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/pages/statement/index.vue